var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficialServiceActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#03a9f4",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 121.797 121.797",
    xmlSpace: "preserve",
    stroke: "#03a9f4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.385,39.658c6.162-0.118,10.231-5.907,10.209-14.551c-0.01-6.207-4.019-9.841-10.695-9.695 c-6.434,0.148-9.987,3.71-9.92,9.939C17.079,34.328,21.041,39.771,27.385,39.658z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.965,
    cy: 23.479,
    r: 13.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.095,
    y: 75.127,
    width: 101.031,
    height: 36.235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.764,68.473c2.698-17.198-11.154-25.716-16.365-28.91c-0.166-0.102-0.348-0.173-0.522-0.252 c-1.431-0.94-3.028-1.629-4.659-2.03l-3.249,3.274l-3.149-3.308c-0.015,0-0.022,0-0.035,0.004 c-1.561,0.372-3.098,1.021-4.482,1.895c-0.345,0.104-0.688,0.24-1.017,0.426c-2.021,1.137-3.94,1.356-6.046,0.702 c-2.717-0.848-5.359-2.99-7.688-5.513l-4.244-5.4c-1.569-2.313-2.773-4.451-3.428-5.793c-1.223-2.517-4.254-3.564-6.77-2.344 c-2.517,1.221-3.566,4.253-2.344,6.771c0.653,1.35,5.253,10.462,12.541,16.744v0.002c0.362-0.478,0.825-0.88,1.38-1.141 l3.646-1.713c0.503-0.233,1.041-0.354,1.591-0.354c1.454,0,2.787,0.848,3.402,2.163c0.423,0.902,0.47,1.922,0.13,2.865 c-0.341,0.942-1.027,1.696-1.933,2.119l-1.187,0.558c0.61,0.261,1.229,0.501,1.866,0.7c1.466,0.458,2.939,0.715,4.41,0.791v17.744 H57.379c0.089-3.983,0.859-14.542,6.471-19.668c0.42,0.117,0.883,0.096,1.312-0.104l3.648-1.714 c0.953-0.445,1.363-1.585,0.916-2.54c-0.447-0.954-1.588-1.364-2.543-0.916l-3.647,1.714c-0.576,0.271-0.952,0.792-1.062,1.376 c-6.738,5.769-7.577,17.493-7.65,21.853h-4.083c0.002-0.017,0.002-0.033,0.005-0.05h-1.153l-2.24-8.846 c-0.05-0.186-0.112-0.365-0.18-0.543L41.86,46.042c-0.446-1.08-1.299-1.857-2.302-2.252v-0.034l-5.524-2.459l-2.262-2.048 l-4.482,4.094l-4.388-4.129l-2.557,2.155l-5.328,2.387v0.194c-0.85,0.431-1.561,1.14-1.951,2.092L7.752,59.035 c-0.072,0.178-0.134,0.357-0.179,0.543l-2.239,8.846H0v3.984h50.484c0-0.003,0-0.006,0-0.01h71.313v-3.926H112.764z M13.77,68.424 l1.247-4.937v3.574c0,0.459,0.021,0.911,0.06,1.36H13.77V68.424z M28.578,68.424h-2.58l-1.964-2.688l3.226-21.537h0.063 l3.219,21.537L28.578,68.424z M39.496,68.424c0.039-0.45,0.063-0.901,0.063-1.361v-4.948l1.599,6.31H39.496L39.496,68.424z M87.997,66.374h-0.06l-3.146-4.307l3.146-21.031h0.06l3.147,21.031L87.997,66.374z M102.429,68.473h-1.11V57.634 C102.85,60.535,103.432,64.056,102.429,68.473z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialServiceActive);
export default __webpack_public_path__ + "static/media/official_service_active.d7fe0a1a1104176b4acf70e46e5fa408.svg";
export { ForwardRef as ReactComponent };